import { Checkbox, ClickAwayListener, Collapse, Divider, IconButton, List, ListItem, ListItemIcon, ListItemText, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, withStyles } from "@material-ui/core";
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { useCallback, useEffect, useMemo, useState } from "react";
import FilterListIcon from '@material-ui/icons/FilterList';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';import MailIcon from '@material-ui/icons/Mail';
import { deepCopy, formatHHMM, formatTimeZoneDate, formatTimeZoneStr, parseUTCDate } from "../../utils/FPEUtils";
import clsx from "clsx";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { coPiAlertState, coPiListDataState, coPiListLoadFailedState, coPiLoadingState, coPiWithoutRelationState } from "../../store/CopilotListState";
import CoPiWithoutRelationObserver from "./CoPiWithoutRelationObserver";
import { timeZoneSelector } from "../../store/TimeZoneState";
import { useTranslation } from "react-i18next";
import { blue } from "@material-ui/core/colors";
import { useLinkableSourceList } from "../../store/AircraftSettingState";
import { useAlert } from "../../hooks/useAlert";
import { removeDuplicateMessagesSelector } from "../../store/AlertState";
import { makeErrorMessage } from "../../utils/ErrorMessageUtil";
import { COMMUNICATE_ERROR_MESSAGE_LINKS_FLIGHT_LIST, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../../constants/ErrorMessage";


const useStyles = makeStyles(() => ({
  coPiList: {
    padding: 10,
    height: 'calc(100% - 20px)'
  },
  controller: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  tableHeader: {
    backgroundColor: '#666666'
  },
  tableCell: {
    color: '#FFFFFF',
    backgroundColor: '#666666',
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#FFFFFF'
    },
    '& .MuiTableSortLabel-root:hover': {
      color: '#FFFFFF'
    }
  },
  tableSortLabel: {
  },
  tableContainer: {
    height: '94%'
  },
  tableContainerWithCoPiWithoutRelation: {
    height: '75%'
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  filterAircraft: {
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    border: 'solid 1px',
    height: 300,
    overflowY: 'scroll',
    zIndex: 3
  },
  filterColumn: {
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    border: 'solid 1px',
    height: 300,
    overflowY: 'scroll',
    zIndex: 3,
    right: 10
  },
  displayNone: {
    display: 'none'
  },
  alert: {
    display: 'flex'
  },
  coPiWithoutRelation: {
    color: '#FF0000',
    height: '18%',
    paddingTop: 10
  },
  coPiWithoutRelationData: {
    height: '100%',
    overflowY: 'scroll'
  },
  coPiWithoutRelationTableContainer: {
    height: '100%'
  },
  coPiWithoutRelationCell: {
    color: '#FF0000'
  },
  exclamationCell: {
    width: 5,
    padding: '0px 6px 0px 16px'
  },
  sbdImeiCell: {
    width: 100,
    padding: '0px 6px'
  },
  obsTimeCell: {
    width: 50,
    padding: '0px 6px'
  },
  messageIconCell: {
    width: 20,
    padding: '0px 6px',
    verticalAlign: 'center'
  },
  messageCell: {
    padding: '0px 6px'
  },
  mailIcon: {
    verticalAlign: 'middle'
  },
  divider: {
    height: 3,
    backgroundColor: '#666666'
  },
  spacer: {
    width: 10
  },
  min85: {
    minWidth: 85
  },
  min80: {
    minWidth: 80
  },
  paddingNone: {
    padding: 0
  },
  widthMax: {
    width: '100%'
  },
  updateStopped: {
    fontSize: 20,
    color: '#FF0000',
    borderRadius: 10,
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    border: 'solid 3px #FF0000',
    height: 17
  }
}));

function nullConvert(a, b) {
  if ((a === null || a === undefined) && (b !== null || b !== undefined)) {
    if (typeof b === 'string') {
      a = '';
    }
    if (typeof b === 'number') {
      a = -1;
    }
  }
  if ((a !== null || a !== undefined) && (b === null || b === undefined)) {
    if (typeof a === 'string') {
      b = '';
    }
    if (typeof a === 'number') {
      b = -1;
    }
  }
  return [a, b];
}

function descendingComparator(a, b, orderBy) {

  const [targetA, targetB] = nullConvert(a[orderBy], b[orderBy]);
  if (targetB < targetA) {
    return -1;
  }
  if (targetB > targetA) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function tableSort(array, order, orderBy) {

  if (orderBy === 'aircraft_code' || orderBy === 'aircraft_name') {
    const newArray = deepCopy(array);
    newArray.sort((a, b) => {
    
      // aircraft_code またはaircraft_nameでソート
      const [aircraftA, aircraftB] = nullConvert(a[orderBy], b[orderBy]);
      if (aircraftA !== aircraftB) {
        if (order === 'asc') {
          if (aircraftA > aircraftB) return 1;
          if (aircraftA < aircraftB) return -1;
          return 0;
        } else {
          if (aircraftA < aircraftB) return 1;
          if (aircraftA > aircraftB) return -1;
          return 0;
        }
      }

      // ETDがあればETDでソート
      if(a.etd_utc || b.etd_utc) {
        const [etdA, etdB] = nullConvert(a.etd_utc, b.etd_utc);
        if (order === 'asc') {
          if (etdA > etdB) return 1;
          if (etdA < etdB) return -1;
          return 0;
        } else {
          if (etdA < etdB) return 1;
          if (etdA > etdB) return -1;
          return 0;
        }
      }

      // ETAでソート
      const [etaA, etaB] = nullConvert(a.eta_utc, b.eta_utc);
      if (order === 'asc') {
        if (etaA > etaB) return 1;
        if (etaA < etaB) return -1;
        return 0;
      } else {
        if (etaA < etaB) return 1;
        if (etaA > etaB) return -1;
        return 0;
      }
    });

    return newArray;

  } else if (orderBy === 'alert') {
    let hasAlert = [];
    let hasNotAlert = [];
    array.forEach(a => {
      if (a.approach_alert_result || a.route_deviation_alert_result || a.cross_flight_plan?.length > 0 || a.unupdated_alert_result) {
        hasAlert.push(a);
      } else {
        hasNotAlert.push(a);
      }
    });
    hasAlert = stableSort(hasAlert, getComparator(order, 'latest_obs_time'));
    hasNotAlert = stableSort(hasNotAlert, getComparator(order, 'latest_obs_time'));
    let ret;
    if (order === 'asc') {
      ret = [...hasNotAlert, ...hasAlert];
    } else {
      ret = [...hasAlert, ...hasNotAlert];
    }
    return ret;
  } else {
    return stableSort(array, getComparator(order, orderBy))
  }
}

const HEADER_CELLS = [
  { id: 'fold', disablePadding: true, text: '', filter: false, sort: false},
  { id: 'aircraft_code', disablePadding: false, text: 'Aircraft Code', unit:'', filter: true, checked: true, sort: true, style: 'min85' },
  { id: 'aircraft_name', disablePadding: false, text: 'Aircraft Name', unit:'', filter: true, checked: true, sort: true, style: 'min85' },
  { id: 'alert', disablePadding: false, text: 'Alert', unit:'', filter: true, checked: true, sort: true, style: 'min85' },
  { id: 'alt_ft', disablePadding: false, text: 'Altitude', unit:'(ft)' , filter: true, checked: true, sort: true, style: 'min85' },
  { id: 'gps_spd', disablePadding: false, text: 'Speed', unit:'(kt)', filter: true, checked: true, sort: true, style: 'min85' },
  { id: 'dep_point_name', disablePadding: false, text: 'DEP', unit:'', filter: true, checked: true, sort: true },
  { id: 'arr_point_name', disablePadding: false, text: 'ARR', unit:'', filter: true, checked: true, sort: true },
  { id: 'etd_utc', disablePadding: false, text: 'ETD', unit:'', filter: true, checked: true, sort: true, style: 'min80' },
  { id: 'atd_utc', disablePadding: false, text: 'ATD', unit:'', filter: true, checked: true, sort: true, style: 'min80' },
  { id: 'sta_utc', disablePadding: false, text: 'STA', unit:'', filter: true, checked: true, sort: true, style: 'min80' },
  { id: 'eta_utc', disablePadding: false, text: 'ETA', unit:'', filter: true, checked: true, sort: true, style: 'min80' },
  { id: 'sbd_imei', disablePadding: false, text: 'SBDIMEI', unit:'', filter: true, checked: true, sort: true },
  { id: 'latest_obs_time', disablePadding: false, text: 'Last Call', unit:'', filter: true, checked: true, sort: true, style: 'min85' },
  { id: 'source', disablePadding: false, text: 'source', unit:'', filter: true, checked: true, sort: true, style: 'min85' },
];

const CustomTableCell = withStyles(() => ({
  sizeSmall: {
    padding: '6px 10px 6px 6px'
  }
}))(TableCell);

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort, columnFilterState } = props;
  const {t} = useTranslation();
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className={classes.tableHeader}>
      <TableRow>
        {HEADER_CELLS.map((headCell) => (
          <CustomTableCell
            key={headCell.id}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            className={clsx((headCell.filter && !columnFilterState.find(s => s.id === headCell.id)?.checked) && classes.displayNone, classes.tableCell, headCell.style && classes[headCell.style])}
          >
            {headCell.sort && 
              <TableSortLabel
                className={classes.widthMax}
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {`${t(headCell.text)}${headCell.unit}`}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            }
          </CustomTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function CopilotListFilter(props) {
  const {classes, columnFilterState, setColumnFilterState, lineFilterState, setLineFilterState} = props;

  return (
    <div className={classes.controller}>
      <SelectCheckboxList title={'Filter Aircraft'} dataList={lineFilterState} setDataList={setLineFilterState} className={classes.filterAircraft} Icon={FilterListIcon}></SelectCheckboxList>
      <UpdateStopped />
      <SelectCheckboxList title={'Filter Column'} dataList={columnFilterState} setDataList={setColumnFilterState} className={classes.filterColumn} Icon={ViewColumnIcon} translation={true}></SelectCheckboxList>
    </div>
  )
}

function SelectCheckboxList(props) {
  const {title, dataList, setDataList, className, Icon, translation} = props;
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState();
  const {t} = useTranslation();

  const handleClickIconButton = () => {
    setOpen(prev => !prev);
  }
  const handleClickAway = () => {
    setOpen(false);
  }
  const handleCheckboxChange = (e, index) => {
    setDataList(prev => {
      const newData = deepCopy(prev);
      newData[index].checked = e.target.checked;
      if (newData.find(d => !d.checked)) {
        setColor({color: blue[400]});
      } else {
        setColor();
      }
      return newData;
    })
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <Tooltip title={title}>
        <IconButton onClick={handleClickIconButton}>
          {/* {icon} */}
          <Icon style={color} />
        </IconButton>
        </Tooltip>
        {
          open ? (
            <div className={className}>
              <List dense>
                {dataList.map((row, index) => {
                  return (
                    <ListItem dense key={`SelectCheckboxList-${row.text}-${index}`}>
                      <ListItemIcon>
                        <Checkbox checked={row.checked} onChange={(e) => handleCheckboxChange(e, index)} size='small'></Checkbox>
                      </ListItemIcon>
                      <ListItemText>{translation ? t(row.text) : row.text}</ListItemText>
                    </ListItem>
                  )
                })}
              </List>
            </div>
          ) : null
        }
      </div>
    </ClickAwayListener>
  )
}

const TABLE_ROW_ODD_CLASS_NAME = 'coPi-list-table-row-odd';
const TABLE_ROW_EVEN_CLASS_NAME = 'coPi-list-table-row-even';
const TABLE_ROW_ALERT_CLASS_NAME = 'coPi-list-table-row-alert';
const TABLE_ROW_ALERT_ANIME_CLASS_NAME = 'coPi-list-table-row-alert-anime';
const TABLE_ROW_ALERT_COLLAPSE_CLASS_NAME = 'coPi-list-table-row-alert-collapse';

function Row(props) {

  const {coPi, index, classes, columnFilterState, lineFilterState, alerts, setAlerts, twoMinAgo} = props;
  const [open, setOpen] = useState(true);
  const timeZone = useRecoilValue(timeZoneSelector);
  const {t} = useTranslation();
  const {linkableSourceList} = useLinkableSourceList();

  const rowVisible = lineFilterState.find(s => s.text === coPi.aircraft_code).checked;
  const colSpan = columnFilterState.slice(columnFilterState.filter(s => s.checked).findIndex(s => s.id === 'alert')).length;
  const showAircraftCode = columnFilterState.find(s => s.id === 'aircraft_code').checked;
  const showAircraftName = columnFilterState.find(s => s.id === 'aircraft_name').checked;
  const showAlert = columnFilterState.find(s => s.id === 'alert').checked;
  const sourceId = coPi.sources.find(s => s.is_latest)?.data_source_id;
  const sourceName = linkableSourceList.find(l => l.data_source_id === sourceId)?.data_source_name;
  let alert;
  if (coPi.flightplan_id) {
    alert = alerts.find(a => a.flightplan_id === coPi.flightplan_id);
  } else {
    alert = alerts.find(a => a.aircraft_code === coPi.aircraft_code);
  }

  let rowStyle;
  if (!alert?.alert_on) {
    if (index % 2 === 1) {
      rowStyle = TABLE_ROW_ODD_CLASS_NAME;
    } else {
      rowStyle = TABLE_ROW_EVEN_CLASS_NAME;
    }
  } else if (alert.alert_on && (alert.confirmed || alert.alert_reception_time < twoMinAgo)) {
    rowStyle = TABLE_ROW_ALERT_CLASS_NAME;
  }

  const handleExpand = () => {
    setOpen(prev => !prev);
  }

  const handleRowClick = alert => {
    if (alert && !alert.confirmed) {
      setAlerts(prev => {
        const newData = deepCopy(prev);
        let target;
        if (alert.flightplan_id) {
          target = newData.find(d => d.flightplan_id === alert.flightplan_id);
        } else {
          target = newData.find(d => d.aircraft_code === alert.aircraft_code);
        }
        target.confirmed = true;
        return newData;
      });
    }
  }

  let alertList = [];
  if (alert) {
    if (alert.route_deviation_alert_result) alertList.push(t('deviation'));
    if (alert.approach_alert_result) alertList.push(t('approach'));
    if (alert.cross_alert_result) alertList.push(t('crossing'));
    if (alert.not_update_alert) alertList.push(t('Non Updated'));
  }

  return (
    <>
      <TableRow
        className={clsx(!rowVisible && classes.displayNone, rowStyle)}
        onClick={() => handleRowClick(alert)}
      >
        <CustomTableCell className={classes.paddingNone}>
          <IconButton onClick={handleExpand} className={clsx(!alert?.alert_on && classes.displayNone)}>
            {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        </CustomTableCell>
        <CustomTableCell className={clsx(!showAircraftCode && classes.displayNone)}>{coPi.aircraft_code}</CustomTableCell>
        <CustomTableCell className={clsx(!showAircraftName && classes.displayNone)}>{coPi.aircraft_name}</CustomTableCell>
        <CustomTableCell className={clsx(!showAlert && classes.displayNone)}>
          {
            alertList.join(', ')
          }
        </CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'alt_ft').checked && classes.displayNone)}>{coPi.alt_ft && Math.round(coPi.alt_ft * 100) / 100}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'gps_spd').checked && classes.displayNone)}>{coPi.gps_spd}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'dep_point_name').checked && classes.displayNone)}>{coPi.dep_point_name}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'arr_point_name').checked && classes.displayNone)}>{coPi.arr_point_name}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'etd_utc').checked && classes.displayNone)}>{formatTimeZoneDate(coPi.etd_utc, timeZone, 'MM/DD HH:mm')}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'atd_utc').checked && classes.displayNone)}>{formatTimeZoneDate(coPi.atd_utc, timeZone, 'MM/DD HH:mm')}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'sta_utc').checked && classes.displayNone)}>{formatTimeZoneDate(coPi.sta_utc, timeZone, 'MM/DD HH:mm')}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'eta_utc').checked && classes.displayNone)}>{formatTimeZoneDate(coPi.eta_utc, timeZone, 'MM/DD HH:mm')}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'sbd_imei').checked && classes.displayNone)}>{coPi.sbd_imei}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'latest_obs_time').checked && classes.displayNone)}>{formatTimeZoneDate(coPi.latest_obs_time, timeZone, 'MM/DD HH:mm')}</CustomTableCell>
        <CustomTableCell className={clsx(!columnFilterState.find(s => s.id === 'source').checked && classes.displayNone)}>{sourceName}</CustomTableCell>
      </TableRow>
      {
        alert?.route_deviation_alert_result &&
        <TableRow className={clsx((!rowVisible || !open || !showAlert) && classes.displayNone, TABLE_ROW_ALERT_COLLAPSE_CLASS_NAME)}>
          <CustomTableCell ></CustomTableCell>
          <CustomTableCell className={clsx(!showAircraftCode && classes.displayNone)}></CustomTableCell>
          <CustomTableCell className={clsx(!showAircraftName && classes.displayNone)}></CustomTableCell>
          <CustomTableCell colSpan={colSpan}>
            <Collapse in={open} unmountOnExit>
              <div className={classes.alert}>
                <div>{t('deviation')}</div>
                <div className={classes.spacer}></div>
                <div>{alert?.deviation_distance_nm && Math.round(alert?.deviation_distance_nm)}NM</div>
              </div>
            </Collapse>
          </CustomTableCell>
        </TableRow>
      }
      {
        alert?.approach_alert_result &&
        <TableRow className={clsx((!rowVisible || !open || !showAlert) && classes.displayNone, TABLE_ROW_ALERT_COLLAPSE_CLASS_NAME)}>
          <CustomTableCell ></CustomTableCell>
          <CustomTableCell className={clsx(!showAircraftCode && classes.displayNone)}></CustomTableCell>
          <CustomTableCell className={clsx(!showAircraftName && classes.displayNone)}></CustomTableCell>
          <CustomTableCell colSpan={colSpan}>
            <Collapse in={open} unmountOnExit>
              <div className={classes.alert}>
                <div>{t('approach')}</div>
                <div className={classes.spacer}></div>
                <div>{alert?.approach_aircraft.map(a => `${a.aircraft_code}(${Math.round(a.h_dist_nm)}NM/${Math.round(a.v_dist_ft)}ft)`).join(', ')}</div>
              </div>
            </Collapse>
          </CustomTableCell>
        </TableRow>
      }
      {
        alert?.cross_alert_result &&
        <TableRow className={clsx((!rowVisible || !open || !showAlert) && classes.displayNone, TABLE_ROW_ALERT_COLLAPSE_CLASS_NAME)}>
          <CustomTableCell ></CustomTableCell>
          <CustomTableCell className={clsx(!showAircraftCode && classes.displayNone)}></CustomTableCell>
          <CustomTableCell className={clsx(!showAircraftName && classes.displayNone)}></CustomTableCell>
          <CustomTableCell colSpan={colSpan}>
            <Collapse in={open} unmountOnExit>
              <div className={classes.alert}>
                <div>{t('crossing')}</div>
                <div className={classes.spacer}></div>
                <div>{alert?.cross_aircraft_code.map(a => `${a.aircraft_code}(ETD${formatTimeZoneDate(a.etd_utc, timeZone, 'HH:mmz')})`).join(', ')}</div>
              </div>
            </Collapse>
          </CustomTableCell>
        </TableRow>
      }
      {
        alert?.unupdated_alert_result &&
        <TableRow className={clsx((!rowVisible || !open || !showAlert) && classes.displayNone, TABLE_ROW_ALERT_COLLAPSE_CLASS_NAME)}>
          <CustomTableCell ></CustomTableCell>
          <CustomTableCell className={clsx(!showAircraftCode && classes.displayNone)}></CustomTableCell>
          <CustomTableCell className={clsx(!showAircraftName && classes.displayNone)}></CustomTableCell>
          <CustomTableCell colSpan={colSpan}>
            <Collapse in={open} unmountOnExit>
              <div className={classes.alert}>
                <div>{t('Non Updated')}</div>
                <div className={classes.spacer}></div>
                <div>{`${alert?.unupdated_time_min} min`}</div>
              </div>
            </Collapse>
          </CustomTableCell>
        </TableRow>
      }
    </>
  );
}

function CoPiWithoutRelation(props) {
  const {classes, filteredCoPiWithoutRelation} = props;
  const timeZone = useRecoilValue(timeZoneSelector);
  const {t} = useTranslation();

  return (
    <div className={classes.coPiWithoutRelation}>
      <Divider className={classes.divider}/>
      <TableContainer className={classes.coPiWithoutRelationTableContainer}>
        <Table stickyHeader size='small'>
          <TableHead>
            <TableRow>
              <CustomTableCell colSpan={5} className={classes.coPiWithoutRelationCell}>
                {t('Unrelated FOSTER-CoPilot')}
              </CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              filteredCoPiWithoutRelation.map((data, index) => {
                return (
                  <TableRow key={`CoPiWithoutRelation-${data.sbd_imei}-${index}`}>
                    <CustomTableCell className={clsx(classes.exclamationCell, classes.coPiWithoutRelationCell)}>!</CustomTableCell>
                    <CustomTableCell className={clsx(classes.sbdImeiCell, classes.coPiWithoutRelationCell)}>{data.sbd_imei}</CustomTableCell>
                    <CustomTableCell className={clsx(classes.obsTimeCell, classes.coPiWithoutRelationCell)}>{`(${formatHHMM(data.time)}${formatTimeZoneStr(timeZone)})`}</CustomTableCell>
                    <CustomTableCell className={clsx(classes.messageIconCell, classes.coPiWithoutRelationCell)}>{data.message && <MailIcon fontSize="small" className={classes.mailIcon}/>}</CustomTableCell>
                    <CustomTableCell className={clsx(classes.messageCell, classes.coPiWithoutRelationCell)}>{data.message}</CustomTableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

function UpdateStopped() {
  const classes = useStyles();
  const coPiLoading = useRecoilValue(coPiLoadingState);
  const {t} = useTranslation();
  return (
    <>
      {!coPiLoading && <div className={classes.updateStopped}>
          <div>
            {t('Data updating has been stopped')}
          </div>
        </div>}
    </>
  )
}

function CopilotListTab() {

  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('aircraft_code');
  const [columnFilterState, setColumnFilterState] = useState(HEADER_CELLS.filter(cell => cell.filter));
  const coPiListData = useRecoilValue(coPiListDataState);
  const [lineFilterState, setLineFilterState] = useState([]);
  const coPiWithoutRelation = useRecoilValue(coPiWithoutRelationState);
  const [alerts, setAlerts] = useRecoilState(coPiAlertState);
  const [filteredCoPiWithoutRelation, setFilteredCoPiWithoutRelation] = useState([]);
  const [coPiListLoadFailed, setCoPiListLoadFailed] = useRecoilState(coPiListLoadFailedState);
  const {showError} = useAlert();
  const removeDuplicateMessages = useSetRecoilState(removeDuplicateMessagesSelector);
  
  const removeMessage = useCallback(() => {
    const errorMessage = makeErrorMessage({
      message: COMMUNICATE_ERROR_MESSAGE_LINKS_FLIGHT_LIST,
      additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
    });
    removeDuplicateMessages(errorMessage);
    return errorMessage;
  }, [removeDuplicateMessages]);

  useEffect(() => {
    if (coPiListLoadFailed) {
      showError(removeMessage());
    } else {
      removeMessage();
    }
  }, [coPiListLoadFailed, removeMessage, showError]);

  const parsedData = useMemo(() => {
    const ret = [];
    coPiListData?.forEach(d => {
      if (d.flight_plan.length > 0) {
        d.flight_plan.forEach(p => {
          ret.push({...d, ...p});
        });
      } else {
        ret.push({...d});
      }
    });
    return ret;
  }, [coPiListData]);

  useEffect(() => {
    if (coPiListData) {
      setCoPiListLoadFailed(false);
    } else {
      setCoPiListLoadFailed(true);
    }
    setLineFilterState(prev => {
      const newData = [...(new Set(coPiListData?.map(coPi => coPi.aircraft_code)))].map(code => {return {text: code, checked: true}});
      newData.forEach(n => {
        const previousState = prev.find(p => p.text === n.text);
        if (previousState) {
          n.checked = previousState.checked;
        }
      })
      return newData;
    });
  }, [coPiListData, setCoPiListLoadFailed]);

  useEffect(() => {
    const filteredData = [];
    const anHourAgoMsec = Date.now() - 60 * 60 * 1000;
    coPiWithoutRelation.forEach(data => {
      if (data.obs_time) {
        const obsTimeMsec = parseUTCDate(data.obs_time);
        if (anHourAgoMsec < obsTimeMsec) {
          filteredData.push({sbd_imei: data.sbd_imei, time: data.obs_time});
          if (data.message_time) {
            filteredData.push({sbd_imei: data.sbd_imei, time: data.message_time, message: data.message});
          }
        }
      }
    });
    setFilteredCoPiWithoutRelation(filteredData);
  }, [coPiWithoutRelation, setFilteredCoPiWithoutRelation]);

  const viewCoPiWithoutRelation = 0 < filteredCoPiWithoutRelation.length;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const twoMinAgo = Date.now() - 2 * 60 * 1000;

  return (
    <div className={classes.coPiList}>
      <CoPiWithoutRelationObserver/>
      <CopilotListFilter
        classes={classes}
        columnFilterState={columnFilterState}
        setColumnFilterState={setColumnFilterState}
        lineFilterState={lineFilterState}
        setLineFilterState={setLineFilterState}
      />
      <TableContainer className={clsx(viewCoPiWithoutRelation ? classes.tableContainerWithCoPiWithoutRelation : classes.tableContainer)}>
        <Table stickyHeader size='small'>
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            columnFilterState={columnFilterState}
          />
          <TableBody className={TABLE_ROW_ALERT_ANIME_CLASS_NAME}>
            {tableSort(parsedData, order, orderBy).map((coPi, index) => {
              return <Row
                key={`coPiList-row-${index}`}
                coPi={coPi}
                index={index}
                classes={classes}
                columnFilterState={columnFilterState}
                lineFilterState={lineFilterState}
                alerts={alerts}
                setAlerts={setAlerts}
                twoMinAgo={twoMinAgo}
              />
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {
        viewCoPiWithoutRelation && <CoPiWithoutRelation classes={classes} filteredCoPiWithoutRelation={filteredCoPiWithoutRelation}/>
      }
    </div>
  )
}

export default CopilotListTab;
